module.exports = __webpack_public_path__ + "img/middenspanning.cd699ec9.png";